"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var maxLabels = 5;
/**
 * Caps the active tab index value at the upper or lower limit to ensure
 * we do not request an item that is out of bounds.
 *
 * @param {integer} [index=0]
 *
 * @returns {integer}
 */

var ensureActiveTabWithinBounds = function ensureActiveTabWithinBounds() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (index > maxLabels - 1) return maxLabels - 1;
  return index;
};
/**
 * @param {integer} x
 * @param {integer} y
 *
 * @returns {string}
 */


var getTransform = function getTransform(x, y) {
  var transform = '';

  if (x) {
    transform += "translateX(".concat(x, "px)");
    if (y) transform += ' ';
  }

  if (y) transform += "translateY(".concat(y, "px)");
  return transform;
};

var DeveloperToolsContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DeveloperToolsContainer, _React$Component);

  function DeveloperToolsContainer() {
    _classCallCheck(this, DeveloperToolsContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(DeveloperToolsContainer).apply(this, arguments));
  }

  _createClass(DeveloperToolsContainer, [{
    key: "renderButton",
    value: function renderButton(label, value, callback) {
      var hasValue = ![undefined, null].includes(value);
      return _react.default.createElement("button", {
        className: _style.default.menuButton,
        onClick: callback,
        type: "button"
      }, label, hasValue && ':', " ", hasValue && _react.default.createElement("span", {
        className: (0, _classnames.default)(_defineProperty({}, _style.default._active, value === true))
      }, value ? 'on' : 'off'));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _classNames2;

      var minimised = this.props.minimised;
      return _react.default.createElement("div", {
        className: _style.default.header
      }, !minimised && this.renderTitle(), _react.default.createElement("ul", {
        className: _style.default.headerList
      }, this.props.onToggle && _react.default.createElement("li", {
        className: _style.default.headerItem
      }, _react.default.createElement(_Button.default, {
        className: (0, _classnames.default)((_classNames2 = {}, _defineProperty(_classNames2, _style.default.headerButton, true), _defineProperty(_classNames2, _style.default._large, minimised), _classNames2)),
        onClick: this.props.onToggle,
        title: minimised ? 'Maximise' : 'Minimise',
        value: minimised ? '+' : '—'
      })), !minimised && this.props.onClose && _react.default.createElement("li", {
        className: _style.default.headerItem
      }, _react.default.createElement(_Button.default, {
        className: _style.default.headerButton,
        onClick: this.props.onClose,
        title: "Close",
        value: "Close"
      }))));
    }
  }, {
    key: "renderInput",
    value: function renderInput(label, value, callback) {
      return _react.default.createElement(_react.default.Fragment, null, label, ": ", _react.default.createElement("input", {
        onChange: callback,
        value: value
      }));
    }
  }, {
    key: "renderItem",
    value: function renderItem(item) {
      var args = [item.label, item.value, item.callback];

      if (typeof item.value === 'string') {
        return this.renderInput.apply(this, args);
      } // TODO: use checkbox instead of buttons for a11y reasons


      if (typeof item.value === 'boolean') {
        return this.renderButton.apply(this, args);
      }

      return this.renderButton.apply(this, args);
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;

      var activeTab = ensureActiveTabWithinBounds(this.props.activeTab);
      var items = this.props.tabItems[activeTab] || [];
      return _react.default.createElement("ul", {
        className: _style.default.menuList
      }, items.map(function (item, index) {
        var _classNames3;

        return item.hide ? null : _react.default.createElement("li", {
          // eslint-disable-line no-confusing-arrow
          className: (0, _classnames.default)((_classNames3 = {}, _defineProperty(_classNames3, _style.default.item, true), _defineProperty(_classNames3, _style.default._input, typeof item.value === 'string'), _classNames3)),
          key: index
        }, _this.renderItem(item));
      }));
    }
  }, {
    key: "renderTabLabels",
    value: function renderTabLabels() {
      var _this2 = this;

      var labels = this.props.tabLabels.slice(0, maxLabels);
      var activeTab = ensureActiveTabWithinBounds(this.props.activeTab);
      return _react.default.createElement("ul", {
        className: _style.default.actionList
      }, labels.map(function (label, index) {
        var _classNames4;

        return _react.default.createElement("li", {
          className: _style.default.actionItem,
          key: index
        }, _react.default.createElement(_Button.default, {
          className: (0, _classnames.default)((_classNames4 = {}, _defineProperty(_classNames4, _style.default.actionButton, true), _defineProperty(_classNames4, _style.default._active, activeTab === index), _classNames4)),
          onClick: function onClick() {
            return _this2.props.onTab && _this2.props.onTab(index);
          },
          value: label
        }));
      }));
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _classNames5;

      var draggable = !!this.props.onDrag;
      return _react.default.createElement("h1", {
        className: (0, _classnames.default)((_classNames5 = {}, _defineProperty(_classNames5, _style.default.title, true), _defineProperty(_classNames5, _style.default._draggable, draggable), _classNames5)),
        draggable: draggable,
        onDrag: this.props.onDrag,
        onDragEnd: this.props.onDragEnd,
        onDragStart: this.props.onDragStart
      }, "Developer Tools");
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames6;

      var minimised = this.props.minimised;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)((_classNames6 = {}, _defineProperty(_classNames6, _style.default.wrapper, true), _defineProperty(_classNames6, _style.default._minimised, minimised), _defineProperty(_classNames6, _style.default._static, !this.props.onToggle), _classNames6)),
        style: {
          transform: getTransform(this.props.x, this.props.y)
        }
      }, this.renderHeader(), !minimised && this.renderItems(), !minimised && this.renderTabLabels());
    }
  }]);

  return DeveloperToolsContainer;
}(_react.default.Component);

var _default = DeveloperToolsContainer;
exports.default = _default;